import { Box, Typography } from '@mui/material'
import { CircleFlag } from '@/components/CircleFlag'
import { VisibleAutocomplete } from '@/components/inputs/VisibleAutocomplete'

import { GeoBlockingMap, GeoRegion } from './GeoBlockingTemplateForm.constants'

type CountryAutocompleteProps = {
  options: GeoRegion[]
  value: GeoRegion[]
  onChange: (value: GeoRegion[]) => void
  placeholder?: string
  maxHeight?: number
}

export const GeoBlockingTemplateCountryAutocomplete = ({
  options,
  value,
  onChange,
  placeholder = 'Search for territories...',
  maxHeight = 192
}: CountryAutocompleteProps) => {
  return (
    <VisibleAutocomplete
      options={options}
      placeholder={placeholder}
      value={value}
      maxHeight={maxHeight}
      onChange={onChange}
      filterOptions={(options, { inputValue }) =>
        options.filter(
          (option) =>
            option.name.toLowerCase().includes(inputValue.toLowerCase()) ||
            option.displayLabel.toLowerCase().includes(inputValue.toLowerCase())
        )
      }
      isOptionEqualToValue={(option, value) => option.iso2 === value.iso2}
      getOptionLabel={(option) => option.name}
      renderOption={(props, option) => (
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            width: '100%',
            gap: 2
          }}
          component="li"
          {...props}
          data-testid={`autocomplete-${option.iso2}`}
          key={`autocomplete-${option.iso2}`}
        >
          <Box
            sx={{
              width: 24,
              height: 24,
              borderRadius: '50%',
              overflow: 'hidden',
              flexShrink: 0,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}
          >
            <CircleFlag countryCode={option.iso2.toLowerCase()} height="100%" width="100%" />
          </Box>

          <Box
            sx={{
              flexGrow: 1,
              display: 'flex',
              alignItems: 'center',
              minWidth: 0,
              userSelect: 'none'
            }}
          >
            <Typography>{option.name}</Typography>
          </Box>

          <Typography
            sx={{
              flexShrink: 0,
              display: 'flex',
              alignItems: 'center',
              fontSize: 13,
              color: 'text.secondary',
              fontWeight: 500,
              userSelect: 'none'
            }}
          >
            {GeoBlockingMap.continents?.[option.continent as keyof typeof GeoBlockingMap.continents]
              ?.name || option.continent}
          </Typography>
        </Box>
      )}
    />
  )
}
